/* eslint-disable sort-keys */
import * as Yup from 'yup'
import { NEWSLETTER_FORM, VALIDATION_TEXT, ERROR_CODES } from './constants'
import React, { useState } from 'react'
import { handleEmailSubmit } from '../../services/newsletter.service'
import styled from 'styled-components'
import { useFormik } from 'formik'

const Container = styled.div`
  @media (min-width: 992px) {
    align-items: center;
    flex-direction: row;
  }
`

const Button = styled.button`
  height: 56px;
  max-width: 80px;
  border: 0;
  border-radius: 0;
  background-image: linear-gradient(90deg, #009bbf, #00c2e2);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .12), 0 0 40px 0 rgba(72, 220, 255, .22);

  font-size: 16px;
  cursor: pointer;
  display: block;
  width: 122px;

  text-transform: uppercase;
  color: #FFF;

  /*  NORMAL DESKTOP MEDIA-QUERY  */
  @media (min-width: 992px) {
    max-width: none;
  }
`

const Title = styled.p`
  font-weight: bold;
  font-size: 16px;
  letter-spacing: -.2px;
  line-height: 1.5;
  margin-bottom: 12px;
  text-align: center;

  @media (min-width: 992px) {
    margin-right: 20px;
    margin-bottom: 0;
    white-space: nowrap;
  }
`

const FormContainer = styled.div`
  form {
    display: flex;
  }
  width: 100%;
  max-width: 325px;
  margin-bottom: 12px;
  border-radius: 3px;
  overflow: hidden;

  @media (min-width: 992px) {
    flex-grow: 1;
    margin-bottom: 0;
    width: 100%;
  }
`

const ResponseText = styled.span`
  font-weight: 700;
  margin-bottom: 12px;
  max-width: 100px;

  @media (min-width: 992px) {
    font-weight: 700;
    margin-left: 20px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
`

const EmailInput = styled.input`
  border: 0;
  color: #666;
  flex-grow: 1;
  font-size: 16px;
  height: 56px;
  line-height: 22px;
  padding: 19px 15px 20px 25px;
  width: 100%;
`

const validationSchema = Yup.object().shape( {
  'newsletter-email': Yup.string().email( VALIDATION_TEXT.invalid )
    .required( VALIDATION_TEXT.invalid )
} )

const NewsletterForm = () => {
  const [ apiError, setApiError ] = useState( false )
  const [ newsletterSuccess, setNewsletterSuccess ] = useState( false )
  const [ alreadyRegisteredEmail, setAlreadyRegisteredEmail ] = useState( false )

  const formik = useFormik( {
    'initialValues': {
      'newsletter-email': ''
    },
    'onSubmit': async values => {
      const data = {
        'dados': {
          'email': values[ 'newsletter-email' ],
          'nome': values[ 'newsletter-email' ],
        },
        'isPF': true,
        'newsletter': true,
        'post': false
      }
      setApiError( false )
      try {
        const result = await handleEmailSubmit( data )
        if ( result.data.id ) {
          setNewsletterSuccess( true )
          setTimeout( () => {
            setNewsletterSuccess( false )
          }, 5000 )
        }
      } catch ( err ) {
        if ( err?.response?.data?.dados?.email[ 0 ] === ERROR_CODES.EMAIL_JA_CADASTRADO ) {
          setAlreadyRegisteredEmail( true )
        } else {
          setAlreadyRegisteredEmail( false )
        }
        setNewsletterSuccess( false )
        setApiError( true )
        setTimeout( () => {
          setApiError( false )
        }, 5000 )
      }
    },
    'validateOnChange': false,
    validationSchema,
  } )

  return (
    <Container className="centered column flex">
      <Title>{ NEWSLETTER_FORM.title }</Title>
      <FormContainer className="flex">
        <form onSubmit={ formik.handleSubmit }>
          <EmailInput
            id="newsletter-email"
            name="newsletter-email"
            onChange={ formik.handleChange }
            placeholder={ NEWSLETTER_FORM.placeholder }
            type="text"
            value={ formik.values[ 'newsletter-email' ] }
          />
          <Button
            className="capitalized branco"
            id="newsletter-button"
            type="submit"
          >
            { NEWSLETTER_FORM.button }
          </Button>
        </form>
      </FormContainer>
      {newsletterSuccess ? ( <ResponseText>{ VALIDATION_TEXT.success }</ResponseText> ) : null}
      {apiError ? ( <ResponseText>{ alreadyRegisteredEmail ? VALIDATION_TEXT.alreadyRegistered : VALIDATION_TEXT.invalid }</ResponseText> ) : null}
      <ResponseText data-testid="error-message">
        { formik.errors[ 'newsletter-email' ] }
      </ResponseText>
    </Container>
  )
}

export default NewsletterForm
